<template>
  <v-theme-provider>
    <base-section
      id="auditcommitte"
      space="40"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <base-section-heading title="Komite Audit" />
            <base-body space="0">
               <v-container fluid>
                <v-row dense>
                  <v-col
                    v-for="card in cards"
                    :key="card.name"
                    md="4"
                    xs="12"
                  >
                    <div 
                      data-aos="fade-in"
                      data-aos-delay="50"
                      data-aos-duration="1000"
                      data-aos-easing="ease-in-out"
                      data-aos-mirror="true"
                      data-aos-once="true"
                      data-aos-anchor-placement="top-center">
                    <v-hover v-slot="{ hover }">
                    <v-card
                    outlined>
                      <v-img
                        :src="require(`@/assets/${card.src}`)"
                        class="white--text align-end"
                        height="350px"
                        :gradient="hover ? '' : 'to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)'"
                        :alt="card.name"
                      >
                      <v-card-title class="body-1" v-text="card.name" v-if="hover===false"></v-card-title>
                      </v-img>
                      <v-card-actions>
                        <div  v-if="hover" class="caption" v-html="card.detail"></div>
                        <div v-else>{{ card.title }}</div>
                      </v-card-actions>
                    </v-card>
                    </v-hover>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'AuditCommitte',
    data: () => ({
            posts: [],
            cards: [
              { name: 'Ahmad Subagyo', title: 'Ketua Komite Audit', src: 'AhmadSubagyo-nologo.png',detail: '<strong>DR. Ahmad Subagyo, S.E., M.M., CRBD.</strong> Lahir di Pekalongan, 12 Februari 1972. Meraih gelar S1 di Fakultas Ekonomi dan S2 di bidang Manajemen dari Universitas Jenderal Soedirman, Purwokerto. Kemudian melanjutkan pendidikan S3 di bidang Pengkajian Ekonomi Islam di UIN Syarif Hidayatullah Jakarta. Beliau menjabat sebagai Komisaris PT Asuransi Takaful Umum sekaligus sebagai Anggota Komite Nominasi dan Remunerasi serta Anggota Komite Audit.' },
              { name: 'Armanto Witjaksono', title: 'Komite Audit', src: 'Komite-Audit-Armanto-Witjaksono.jpg', detail: '<strong>Armanto Witjaksono, S.E., Ak., M.M., C.A., Cert.DA.</strong> lahir di Bandung pada 24 Juni 1969. Meraih gelar S1 Ekonomi di bidang Akuntansi dari Universitas Padjadjaran pada tahun 1993 dan S2 Manajemen di Universitas Gadjah Mada pada tahun 1996. Karier profesionalnya dimulai sebagai auditor di Ernst & Young Jakarta, kemudian melanjutkan sebagai Accounting Analyst di 3M. Selain berpengalaman di dunia korporasi termasuk di PT Bank UFJ Indonesia dan MUFG Jakarta Branch, ia juga aktif di dunia akademik sebagai dosen di Universitas Bina Nusantara dan dosen tamu di Universitas Padjadjaran. Sejak 1 September 2019, beliau menjabat sebagai anggota Komite Audit PT Asuransi Takaful Umum.' },
              { name: 'Ainul Hidayati', title: 'Komite Audit', src: 'Komite-Audit-Ainul-Hidayati.jpg', detail: '<strong>Ainul Hidayati, S.Si., AAAIK. </strong> lahir di Jakarta dan meraih gelar Sarjana Sains di bidang Matematika (Statistika) dari Universitas Indonesia pada tahun 2003, serta gelar profesional Ajun Ahli Asuransi Indonesia Kerugian (AAAIK) dari AAMAI pada tahun 2006. Berpengalaman lebih dari 15 tahun di industri asuransi umum, khususnya di bidang underwriting, reasuransi fakultatif dan treaty, serta pengembangan produk. Karier profesionalnya dimulai dari program Management Trainee di PT Asuransi Takaful Umum hingga menjabat sebagai Head of Reinsurance, kemudian melanjutkan kariernya sebagai Head of Reinsurance Department di PT Asuransi Samsung Tugu. Saat ini, beliau menjabat sebagai anggota Komite Audit PT Asuransi Takaful Umum sejak 17 April 2025.' },
            ],
        }),
  }
</script>
npm 